import React from 'react';

import InfoMessage from '@swf/components/InfoMessage/InfoMessage';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';
import { StatusCode } from '@swf/core/enums/statusCode';

import { ExclusionTime } from '../../../shared/definitions';
import AccountDate from '../../AccountDate/AccountDate';
import { ExclusionType } from '../../definitions';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_16,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_WeXll_automatically_reopen_you_ELL,
  TXTWCL_WeXll_automatically_reopen_you_ELL_1,
  TXTWCL_We_canXt_process_your_request__ELL_1,
  TXTWCL_When_your_break_endsX_you_will_ELL_1,
  TXTWCL_YouXre_taking_a_break
} from './ExclusionResponseUSNJ.messages.json';

interface Props {
  error?: boolean;
  statusCode?: StatusCode;
  timeUntil?: number | string;
  daysRequested?: number;
  exclusionType?: ExclusionType;
}

const ExclusionResponseUSNJ: React.FC<Props> = ({
  error,
  statusCode,
  timeUntil,
  daysRequested,
  exclusionType
}) => {
  const currentDate = new Date();
  let endDate;
  if (timeUntil) {
    endDate = new Date(timeUntil);
  } else {
    const daysToAdd =
      daysRequested && daysRequested > ExclusionTime.OneDay
        ? ExclusionTime.ThirtyDays
        : ExclusionTime.OneDay;
    endDate = currentDate.setDate(currentDate.getDate() + daysToAdd);
  }
  const formattedEndDate = (
    <b>
      <AccountDate date={endDate} />
    </b>
  );

  switch (true) {
    case error:
      return (
        <InfoMessage type="error">
          <Translation {...TXTWCL_We_canXt_process_your_request__ELL_1} />
        </InfoMessage>
      );

    case exclusionType === ExclusionType.Break && statusCode === StatusCode.USER_SELF_EXCLUDED:
      return (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_taking_a_break}>
          <Translation
            {...TXTWCL_WeXll_automatically_reopen_you_ELL_1}
            values={{
              0: formattedEndDate
            }}
          />
        </InfoMessage>
      );

    case statusCode === StatusCode.USER_SELF_EXCLUDED &&
      exclusionType === ExclusionType.SelfExclusion:
      return (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_taking_a_break}>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
            values={{ 0: formattedEndDate }}
          />{' '}
          <Translation
            {...TXTWCL_When_your_break_endsX_you_will_ELL_1}
            values={{
              a: (msg: string) => (
                <ResolverLink resolverTag={ResolverTag.RGNJOAG}>{msg}</ResolverLink>
              )
            }}
          />
        </InfoMessage>
      );
    case !statusCode && exclusionType === ExclusionType.SelfExclusion:
      return (
        <>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_16}
            values={{ 0: formattedEndDate }}
          />{' '}
          <Translation
            {...TXTWCL_When_your_break_endsX_you_will_ELL_1}
            values={{
              a: (msg: string) => (
                <ResolverLink resolverTag={ResolverTag.RGNJOAG}>{msg}</ResolverLink>
              )
            }}
          />
        </>
      );

    default:
      return (
        <>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
            values={{ 0: formattedEndDate }}
          />{' '}
          <Translation {...TXTWCL_WeXll_automatically_reopen_you_ELL} />
        </>
      );
  }
};

export default ExclusionResponseUSNJ;
